import { processImageUrl } from '@/lib/utils/image-url'
import Image, { ImageProps } from 'next/image'

export const ImageCM = ({
  src,
  width,
  height,
  quality = 80,
  useMediaUrl = false,
  ...props
}: {
  src: string
  width?: number
  height?: number
  quality?: number
  useMediaUrl?: boolean
  alt?: string
} & Omit<ImageProps, 'src' | 'width' | 'height' | 'alt'>) => {
  const imageUrl = processImageUrl(src, width, height, useMediaUrl)

  if (!imageUrl) return null

  return (
    <Image
      src={imageUrl}
      alt={props?.alt || 'Image'}
      width={width || 100}
      height={height || 100}
      quality={quality}
      {...props}
    />
  )
}
